module.exports = __webpack_public_path__ + "p3_img2.jpg?e1980d4fbcebd079975bf6ad622ecbcb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img2.jpg
// module id = 118
// module chunks = 0